// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1g_Jb","name":"ConsentHeader_name__21k1S","birthday":"ConsentHeader_birthday__2KMJo","skeleton":"ConsentHeader_skeleton__34q9q"};